import { render, staticRenderFns } from "./invitefriend.vue?vue&type=template&id=7e454178"
import script from "./invitefriend.vue?vue&type=script&lang=js"
export * from "./invitefriend.vue?vue&type=script&lang=js"
import style0 from "./invitefriend.vue?vue&type=style&index=0&id=7e454178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports